/* eslint-disable react/require-default-props */
/* eslint-disable no-return-assign */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { DataGrid } from '@mui/x-data-grid';
import { Button, IconButton, Stack } from '@mui/material';

import api from '../../../services/api';
import PointFormModal from '../PointFormModal';

import './styles.css';

export default function PointsCard({
  scrollToMapComponent,
  points,
  setPoints,
  setAudioFile,
  setImageFile,
  setFormData,
  setFormEditData,
  selectedCoords,
  setSelectedCoords,
  setSelectedPoint,
  categories,
}) {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [pointToEdit, setPointToEdit] = useState(null);

  const openCreate = () => {
    setPointToEdit(null);
    setModalOpen(true);
  };

  const openEdit = (point) => {
    setPointToEdit(point);
    setModalOpen(true);
  };

  const handleSaved = (updatedPoint) => {
    setPoints(points.map((p) => (p.id === updatedPoint.id ? { ...p, ...updatedPoint } : p)));
  };

  const onlyGps = points.filter((point) => point.type === 'gps');

  const handleDeletePoint = async (pointObj) => {
    try {
      const deleteAudioFilePromise = pointObj.audioUrl ? api.delete(`/points/file/audio/${pointObj.id}`) : null;
      const deleteImageFilePromise = pointObj.imageUrl ? api.delete(`/points/file/image/${pointObj.id}`) : null;
      const deletePointPromise = api.delete(`/points/${pointObj.id}`);

      // ask for confirmation before delete
      const confirmation = window.confirm('Tem certeza que deseja excluir este ponto?');

      if (!confirmation) return;

      await Promise.allSettled([
        deleteAudioFilePromise,
        deleteImageFilePromise,
        deletePointPromise,
      ]);
      setPoints(points.filter((point) => point.id !== pointObj.id));
      setAudioFile(null);
      setImageFile(null);
      setFormData({
        type: 'gps',
        name: '',
        category: '',
        description: '',
        radius: 10,
        beacon: '',
        isVisible: true,
        isAutomaticallyPlayed: true,
        audioUrl: '',
        imageUrl: '',
      });
      setFormEditData({
        id: '',
        name: '',
        categoryId: '',
        category: '',
        description: '',
        type: 'gps',
        radius: 10,
        beacon: '',
        isVisible: true,
        isAutomaticallyPlayed: true,
        audioURL: '',
        imageURL: '',
      });
      setSelectedCoords({
        lat: null,
        lng: null,
      });
      setSelectedPoint(null);
      alert('Ponto excluído com sucesso!');
    } catch (err) {
      console.error(err);
    }
  };

  const renderCellAction = (params) => (
    <Stack direction="row" spacing={1}>
      <IconButton
        size="small"
        aria-label="Editar por coordenadas"
        onClick={(e) => {
          e.stopPropagation();
          openEdit(params.row);
        }}
      >
        <EditIcon fontSize="small" />
      </IconButton>
      <IconButton
        size="small"
        aria-label="Excluir"
        onClick={(e) => {
          e.stopPropagation();
          handleDeletePoint(params.row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Stack>
  );

  const renderName = (params) => {
    const handleNameClick = () => {
      if (!selectedCoords.lat && !selectedCoords.lng) {
        setSelectedPoint(params.row);
        setFormEditData({
          id: params.row.id,
          type: params.row.type,
          name: params.row.name,
          categoryId: params.row.categoryId,
          category: params.row.category,
          description: params.row?.description,
          radius: params.row.radius,
          beacon: params.row.beacon,
          isVisible: params.row.isVisible,
          isAutomaticallyPlayed: params.row.isAutomaticallyPlayed,
          audioURL: params.row.audioURL,
          imageURL: params.row.imageURL,
          linkURL: params.row.linkURL,
          linkTitle: params.row.linkTitle,
        });
        scrollToMapComponent();
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        handleNameClick();
      }
    };

    return (
      <span
        onClick={handleNameClick}
        onKeyDown={handleKeyDown} // Adicione este ouvinte de teclado
        role="button" // Adicione o papel do elemento
        tabIndex={0} // Torne o elemento focável
        style={{
          cursor: 'pointer',
          color: '#414141',
        }}
      >
        {params.row.name}
      </span>
    );
  };

  const renderVisibility = (params) => {
    const paramsApi = params.api;
    const thisRow = {};
    paramsApi
      .getAllColumns()
      .filter((c) => c.field !== 'action' && !!c)
      .forEach((c) => (thisRow[c.field] = params.row[c.field]));
    const rowAllValues = {
      ...thisRow,
      id: params.id,
      createdAt: points.find((c) => c.id === params.id).createdAt,
      updatedAt: points.find((c) => c.id === params.id).updatedAt,
      latitude: points.find((c) => c.id === params.id).latitude,
      longitude: points.find((c) => c.id === params.id).longitude,
    };
    return <span>{rowAllValues.isVisible ? 'Visível' : 'Invisível'}</span>;
  };

  const columns = [
    {
      field: 'action',
      headerName: '#',
      sortable: false,
      headerAlign: 'center',
      disableColumnMenu: true,
      renderCell: renderCellAction,
      minWidth: 110,
      flex: 1,
    },
    {
      field: 'name',
      headerName: 'Nome',
      headerAlign: 'center',
      renderCell: renderName,
      minWidth: 140,
      flex: 2,
    },
    {
      field: 'category',
      headerName: 'Categoria',
      headerAlign: 'center',
      minWidth: 120,
      flex: 2,
    },
    {
      field: 'radius',
      headerName: 'Raio',
      headerAlign: 'center',
      minWidth: 80,
      flex: 1,
    },
    {
      field: 'isVisible',
      headerName: 'Visibilidade',
      headerAlign: 'center',
      renderCell: renderVisibility,
      minWidth: 120,
      flex: 2,
    },
  ];

  const dataGridStyles = {
    mt: 2,
    border: 'none',
    '& .MuiDataGrid-columnSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-row': {
      borderBottom: 'none',
    },
    '& .MuiDataGrid-rowSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-cell': {
      // borderBottom: 'none',

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
  };

  return (
    <div className="points-card">
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 8,
      }}
      >
        <span className="points-title">
          <h1>Pontos</h1>
        </span>
        <Button
          variant="contained"
          color="success"
          size="small"
          startIcon={<AddIcon />}
          onClick={openCreate}
        >
          Cadastrar por coordenadas
        </Button>
      </div>
      <p
        style={{
          color: '#666',
          fontSize: 13,
          marginTop: 4,
          marginBottom: 0,
        }}
      >
        Você também pode cadastrar um ponto GPS clicando diretamente no mapa acima.
      </p>
      <DataGrid
        sx={dataGridStyles}
        autoHeight
        rows={onlyGps}
        columns={columns}
        rowsPerPageOptions={[5]}
        pageSize={5}
        disableSelectionOnClick
      />
      <PointFormModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        type="gps"
        categories={categories || []}
        pointToEdit={pointToEdit}
        onCreated={(newPoint) => setPoints([...points, newPoint])}
        onSaved={handleSaved}
      />
    </div>
  );
}

PointsCard.propTypes = {
  scrollToMapComponent: PropTypes.func.isRequired,
  points: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      latitude: PropTypes.string.isRequired,
      longitude: PropTypes.string.isRequired,
      isVisible: PropTypes.bool.isRequired,
      createdAt: PropTypes.string.isRequired,
      updatedAt: PropTypes.string.isRequired,
    }),
  ).isRequired,
  setPoints: PropTypes.func.isRequired,
  setAudioFile: PropTypes.func,
  setImageFile: PropTypes.func,
  setFormData: PropTypes.func,
  setFormEditData: PropTypes.func,
  selectedCoords: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  setSelectedCoords: PropTypes.func,
  setSelectedPoint: PropTypes.func,
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })),
};
